

















































































































































import Vue from "vue";
import Space from "@/components/mobile/Space.vue";
import { mapState, mapActions } from "vuex";

export default Vue.extend({
  name: "CommonHeader",
  data() {
    return {
      showSubMenu: false,
      menuIndex: -1,
      menuList: [
        {
          name: "PRODUCTS",
          key: "products",
          href: "/",
          showMenu: false,
          child: [
            {
              name: "LEGEND OTC",
              key: "legend-otc",
              icon: "otc"
            },
            {
              name: "LEGEND PAY",
              key: "legend-pay",
              icon: "pay"
            },
            {
              name: "TRADE WITH US",
              key: "kyc"
            }
          ]
        },
        {
          name: "DEVELOPERS",
          href: "/",
          key: "developers",
          showMenu: false,
          child: []
        },
        {
          name: "SHOWCASES",
          href: "/",
          key: "cases",
          showMenu: false,
          child: []
        },
        {
          name: "COMPANY",
          href: "/",
          key: "company",
          showMenu: false,
          child: [
            {
              name: "ABOUT US",
              icon: "legend",
              desc:
                "We believe the future of global finance should be open to everyone.",
              key: "about"
            },
            {
              name: "BECOME A PARTNER",
              icon: "partner",
              key: "partner"
            },
            {
              name: "SUPPORT HELP CENTER",
              icon: "support",
              key: "https://support.legendtrading.com/hc/"
            }
          ]
        },
        {
          name: "CONTACT",
          href: "/",
          key: "contact",
          showMenu: false,
          child: []
        }
      ]
    };
  },
  computed: {
    ...mapState({
      open: (state: any) => state.isZendeskOpened
    })
  },
  methods: {
    ...mapActions(["toggleZendesk"]),
    onTouched() {
      this.toggleZendesk(!this.open);
    }
  },
  components: {
    MobileSpace: Space
  }
});
